import { Component } from '@angular/core'
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './confirm.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [FaIconComponent],
})
export class ConfirmComponent {
    faQuestionCircle = faQuestionCircle
    constructor(private _activeModal: NgbActiveModal) {}

    public title!: string
    public message!: string

    public yes(): void {
        this._activeModal.close()
    }
    public no(): void {
        this._activeModal.dismiss('cancel')
    }
}
